import {Component, OnInit} from '@angular/core';
import {SubjectTest} from '../../models/subject-test';
import {ActivatedRoute, Router} from '@angular/router';
import {SubjectTestService} from '../../services/subject-test.service';
import {Languages, SCIENCE_LESSONS} from '../../const/common';
import {Student} from '../../models/student';
import {LocalStrorageService} from '../../services/local-strorage.service';
import {StudentService} from '../../services/student.service';

@Component({
  selector: 'app-subject-test',
  templateUrl: './subject-test.component.html',
  styleUrls: ['./subject-test.component.scss']
})
export class SubjectTestComponent implements OnInit {

  currentSubjectTest: SubjectTest = new SubjectTest();
  showResult = false;
  openSide = false;
  countDownTimer = '';
  isSubmitted = false;
  currentSubjectTestId: string;
  lesson: string;
  student: Student;
  test: SubjectTest;
  wrongAnswers = 0;
  unmarkedAnswers = 0;
  correctAnswers = 0;
  totalScore = 0;
  currentTestDuration = 60;
  languages = Languages;
  isCompleted = false;
  ansBox = {
    1: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    2: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    3: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    4: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    5: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    6: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    7: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    8: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    9: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    10: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    11: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    12: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    13: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    14: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    15: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    16: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    17: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    18: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    19: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    20: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    21: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    22: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    23: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    24: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    25: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    26: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    27: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    28: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    29: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    30: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    31: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    32: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    33: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    34: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    35: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    36: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    37: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    38: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    39: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    40: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    41: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    42: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    43: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    44: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    45: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    46: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    47: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    48: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    49: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    },
    50: {
      firstSelectedAns: '',
      reSelectedAns: '',
      countSelect: 0
    }
  };
  options = [
    {label: 'A', ru: 'А'},
    {label: 'B', ru: 'Б'},
    {label: 'C', ru: 'В'},
    {label: 'D', ru: 'Г'}
  ];
  interval;
  answerSelected: any;
  currentLang = Languages.kg;
  science = SCIENCE_LESSONS;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private localStorageService: LocalStrorageService,
              private studentService: StudentService,
              private subjectTestService: SubjectTestService) {
  }

  async ngOnInit(): Promise<any> {
    this.student = this.localStorageService.getStudent();

    if (this.student) {
      this.student = await this.studentService.getStudent(this.student.phone);
    }

    this.route.paramMap.subscribe(params => {
      this.currentSubjectTestId = params.get('id');
      this.currentLang = params.get('lang');
      let counter = 0;
      this.subjectTestService.getSubjectTestById(this.currentSubjectTestId).then((currentTest: SubjectTest) => {
        const hasPermission = this.userHasPermission();
        this.student.examResults.forEach(t => {
          if (t.subjectTestId === this.currentSubjectTestId) {
            counter++;
          }
        });

        if (hasPermission) {
          if (counter < hasPermission.attempts) {
            this.currentSubjectTest = currentTest;
            this.currentTestDuration = this.calculateDuration();
            if (JSON.parse(localStorage.getItem(`ansBox-${this.currentSubjectTestId}`)) !== null) {
              this.ansBox = JSON.parse(localStorage.getItem(`ansBox-${this.currentSubjectTestId}`));
            }
            this.isCompleted = false;
            this.startTimer(this.currentTestDuration);
          }
          else {
            this.isCompleted = true;
            // show message you already completed this exam {{this.currentSubject.attempts}} times
            console.log('already completed');
          }
        } else {
          // this.hasExamCompleted = true;
          this.router.navigateByUrl(`subject-test/${this.currentSubjectTest._id}/permission`);
        }
      });
    });
  }

  // tslint:disable-next-line:typedef
  onChange(event, item: number) {
    this.answerSelected = true;
    const currentObj = this.ansBox[item];
    if (currentObj.countSelect === 1 && currentObj.firstSelectedAns !== event) {
      currentObj.reSelectedAns = event;
      currentObj.countSelect++;
    }
    if (currentObj.countSelect === 0) {
      currentObj.firstSelectedAns = event;
      currentObj.countSelect++;
    }
    console.log(this.ansBox);
  }

  openSideBox(): void {
    this.openSide = !this.openSide;
  }


  // tslint:disable-next-line:typedef
  startTimer(num) {
    // TODO: use countDownTimer service later
    const timer = localStorage.getItem(`timer-${this.currentSubjectTestId}`);

    if (timer !== null) {
      num = parseInt(timer, 10);
    } else {
      num = 60 * parseInt(num, 10);
    }
    this.interval = setInterval(() => {
      if (num > 0) {
        num--;
        let minutes = (num / 60);
        minutes = Math.floor(minutes);
        const seconds = num % 60;
        let second = seconds.toString();
        if (second.length === 1) {
          second = '0' + second;
        }
        this.countDownTimer = minutes + ':' + second;
        if (!this.isSubmitted) {
          localStorage.setItem(`timer-${this.currentSubjectTestId}`, num);
        }
      }
      if (num <= 0) {
        this.checkTest();
        // localStorage.clear();
      }
    }, 1000);
  }

  checkTest(): any {
    this.isSubmitted = true;
    clearInterval(this.interval);
    this.addNewExamResult();
    this.showResult = true;
  }

  finishReview(): void {
    this.router.navigateByUrl(`/subject-test-list/${this.currentSubjectTest.lesson.toLowerCase()}`);
  }

  finish(): void {
    this.router.navigateByUrl(`/subject-list`);
  }

  addNewExamResult(): void {
    this.subjectTestService.submitSubjectTest(this.student._id, this.currentSubjectTestId, this.ansBox)
      .then((res: any) => {
        this.totalScore = res.totalScore;
        this.wrongAnswers = res.wrongAnswers + res.unmarkedAnswers;
        this.correctAnswers = res.correctAnswers;
        this.showResult = true;
        localStorage.removeItem(`ansBox-${this.currentSubjectTestId}`);
        localStorage.removeItem(`timer-${this.currentSubjectTestId}`);
      });
  }

  private userHasPermission(): any {
    const subjectTestAccess = this.student?.availableSubjectTests
      .find(item => item.test._id === this.currentSubjectTestId);
    return subjectTestAccess;
  }

  private calculateDuration(): number {
    if (this.science.includes(this.currentSubjectTest.lesson)) {
      return 80;
    }
    return 60;
  }
}
